import { useEffect, useRef, useState } from 'react';
import { MessageCircle, Phone, Send, X } from 'lucide-react';
import type { FloatingContactsFabProps } from './FloatingContactsFab.types';
import './FloatingContactsFab.scss';

const DEFAULTS = {
  telegram: 'https://t.me/mrbek112',
  whatsapp: 'https://wa.me/998900770302',
  phone: 'tel:+998900770302',
};

export default function FloatingContactsFab({
  telegram = DEFAULTS.telegram,
  whatsapp = DEFAULTS.whatsapp,
  phone = DEFAULTS.phone,
  className,
}: FloatingContactsFabProps) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (!rootRef.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  return (
    <div ref={rootRef} className={['fab-contacts', open ? 'fab-contacts--open' : '', className || ''].filter(Boolean).join(' ')}>
      <div className="fab-contacts__menu" aria-hidden={!open}>
        <a href={telegram} target="_blank" rel="noopener noreferrer" className="fab-contacts__link fab-contacts__link--tg" aria-label="Telegram">
          <Send size={18} />
        </a>
        <a href={whatsapp} target="_blank" rel="noopener noreferrer" className="fab-contacts__link fab-contacts__link--wa" aria-label="WhatsApp">
          <MessageCircle size={18} />
        </a>
        <a href={phone} className="fab-contacts__link fab-contacts__link--phone" aria-label="Phone">
          <Phone size={18} />
        </a>
      </div>
      <button
        type="button"
        aria-label={open ? 'Закрыть контакты' : 'Открыть контакты'}
        aria-expanded={open}
        className="fab-contacts__toggle"
        onClick={() => setOpen(o => !o)}
      >
        {open ? <X size={22} /> : <MessageCircle size={22} />}
      </button>
    </div>
  );
}
